export default __webpack_public_path__ + "static/media/questionmark-in-circle.dc68c838.svg";